/** Cookie consent (plain functions, safe to import from server code; read/write only in the browser). */

const COOKIE_NAME = 'acceptCookie';
const MAX_AGE = 365 * 24 * 60 * 60;

export type Consent = 'accepted' | 'declined' | 'unknown';

const listeners = new Set<() => void>();

export const readConsent = (): Consent => {
  if (typeof document === 'undefined') {
    return 'unknown';
  }
  const value = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_NAME}=`))
    ?.split('=')[1];
  return value === 'true' ? 'accepted' : value === 'false' ? 'declined' : 'unknown';
};

export const setConsent = (accepted: boolean) => {
  document.cookie = `${COOKIE_NAME}=${accepted}; Max-Age=${MAX_AGE}; Path=/; SameSite=Lax`;
  listeners.forEach((listener) => listener());
};

export const subscribeConsent = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
